var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHintIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.885 75.154 h -15.77 c -1.864 0 -3.381 -1.517 -3.381 -3.381 v -7.578 c 0 -4.308 -2.004 -8.363 -5.499 -11.129 c -7.019 -5.555 -10.832 -14.215 -10.2 -23.166 c 0.947 -13.42 11.79 -24.176 25.222 -25.02 C 50.809 4.4 58.006 6.988 63.504 12.15 c 5.421 5.092 8.53 12.275 8.53 19.71 c 0 8.405 -3.813 16.189 -10.459 21.355 c -3.324 2.583 -5.31 6.688 -5.31 10.979 v 7.58 C 56.266 73.638 54.749 75.154 52.885 75.154 z M 45.018 6.826 c -0.543 0 -1.087 0.017 -1.636 0.051 C 30.946 7.658 20.907 17.616 20.03 30.041 c -0.585 8.292 2.946 16.313 9.446 21.457 c 3.977 3.147 6.258 7.775 6.258 12.697 v 7.578 c 0 0.762 0.62 1.381 1.381 1.381 h 15.77 c 0.762 0 1.381 -0.619 1.381 -1.381 v -7.58 c 0 -4.903 2.273 -9.599 6.083 -12.559 c 6.155 -4.783 9.686 -11.992 9.686 -19.775 c 0 -6.985 -2.806 -13.468 -7.899 -18.252 C 57.442 9.202 51.416 6.826 45.018 6.826 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.409 85.174 h -6.818 c -2.929 0 -5.311 -2.382 -5.311 -5.311 v -5.709 c 0 -0.553 0.448 -1 1 -1 H 52.72 c 0.553 0 1 0.447 1 1 v 5.709 C 53.72 82.792 51.338 85.174 48.409 85.174 z M 38.28 75.154 v 4.709 c 0 1.825 1.485 3.311 3.311 3.311 h 6.818 c 1.825 0 3.311 -1.485 3.311 -3.311 v -4.709 H 38.28 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89 32.334 H 78.418 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 H 89 c 0.553 0 1 0.448 1 1 S 89.553 32.334 89 32.334 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.583 32.334 H 1 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 10.583 c 0.552 0 1 0.448 1 1 S 12.135 32.334 11.583 32.334 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.229 16.133 c -0.352 0 -0.693 -0.186 -0.876 -0.515 c -0.268 -0.483 -0.093 -1.092 0.391 -1.359 l 9.256 -5.13 c 0.482 -0.268 1.092 -0.093 1.359 0.39 s 0.093 1.092 -0.391 1.359 l -9.256 5.13 C 74.559 16.093 74.393 16.133 74.229 16.133 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.518 53.666 c -0.352 0 -0.693 -0.186 -0.875 -0.516 c -0.268 -0.482 -0.093 -1.091 0.39 -1.359 l 9.255 -5.131 c 0.483 -0.267 1.091 -0.093 1.359 0.391 c 0.268 0.482 0.093 1.091 -0.39 1.359 l -9.255 5.131 C 6.848 53.626 6.682 53.666 6.518 53.666 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.771 16.133 c -0.164 0 -0.33 -0.04 -0.484 -0.125 l -9.255 -5.13 C 5.549 10.609 5.374 10 5.642 9.518 C 5.91 9.035 6.518 8.86 7.001 9.128 l 9.255 5.13 c 0.483 0.268 0.658 0.876 0.39 1.359 C 16.464 15.947 16.123 16.133 15.771 16.133 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.482 53.666 c -0.164 0 -0.33 -0.04 -0.483 -0.125 l -9.256 -5.131 c -0.483 -0.269 -0.658 -0.877 -0.391 -1.359 c 0.268 -0.484 0.878 -0.658 1.359 -0.391 l 9.256 5.131 c 0.483 0.269 0.658 0.877 0.391 1.359 C 84.176 53.48 83.834 53.666 83.482 53.666 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 41.979 c -2.429 0 -4.406 -1.977 -4.406 -4.406 V 18.275 c 0 -2.429 1.977 -4.406 4.406 -4.406 c 2.429 0 4.405 1.977 4.405 4.406 v 19.298 C 49.405 40.003 47.429 41.979 45 41.979 z M 45 15.87 c -1.327 0 -2.406 1.079 -2.406 2.406 v 19.298 c 0 1.327 1.079 2.406 2.406 2.406 c 1.326 0 2.405 -1.079 2.405 -2.406 V 18.275 C 47.405 16.949 46.326 15.87 45 15.87 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 54.13 c -2.429 0 -4.406 -1.977 -4.406 -4.405 V 49.23 c 0 -2.43 1.977 -4.406 4.406 -4.406 c 2.429 0 4.405 1.976 4.405 4.406 v 0.494 C 49.405 52.153 47.429 54.13 45 54.13 z M 45 46.825 c -1.327 0 -2.406 1.079 -2.406 2.405 v 0.494 c 0 1.326 1.079 2.405 2.406 2.405 c 1.326 0 2.405 -1.079 2.405 -2.405 V 49.23 C 47.405 47.904 46.326 46.825 45 46.825 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintIcon);
export default __webpack_public_path__ + "static/media/hint-icon.baef160f743b74439609f57345325e0d.svg";
export { ForwardRef as ReactComponent };